// extracted by mini-css-extract-plugin
module.exports = {"staticPageWrapper":"Career_staticPageWrapper__1eDxE"};